<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fab fa-youtube</v-icon>
        <span class="title ml-2">Videos</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-btn color="primary" @click="showAdd = true">Agregar</v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="videos"
          hide-default-footer
          :items-per-page="25"
        >
          <template v-slot:item.thumb="{ item }">
            <v-img :src="item.thumb" width="100px" />
          </template>
          <template v-slot:item.opciones="{ item }">
            <v-btn small fav text color="primary" @click="displayVideo(item.id_video)" class="ml-2">
              <v-icon>fas fa-play</v-icon>
            </v-btn>
            <v-btn small fav text color="error" @click="deleteVideo(item.id)">
              <v-icon>fas fa-trash</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="pages"
        ></v-pagination>
      </v-card-text>
    </v-card>
    <!-- =================================================================== -->
    <!-- Dialogs -->
    <!-- =================================================================== -->
    <v-dialog v-model="showAdd" max-width="500px">
      <AddVideo
        @close="showAdd = false"
        @saved="refresh"
      ></AddVideo>
    </v-dialog>
    <v-dialog v-model="showVideo" max-width="650px" class="black">
      <v-card color="black">
        <div class="video-responsive">
          <iframe :src="selectedURL" frameborder="0" allowfullscreen></iframe>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import AddVideo from '../components/AddVideo'
export default {
  data () {
    return {
      videos: [],
      headers: [
        { text: 'Video', value: 'url', sortable: false },
        { text: 'Título', value: 'titulo', sortable: false },
        { text: 'Miniatura', value: 'thumb', sortable: false },
        { text: 'Opciones', value: 'opciones', sortable: false }
      ],
      page: 1,
      pages: 1,
      selectedURL: null,
      showAdd: false,
      showVideo: false
    }
  },
  components: {
    AddVideo
  },
  async created () {
    await this.getPages()
    await this.getVideos()
  },
  methods: {
    async getPages () {
      const { data } = await this.$http.videos.get('/count')
      this.pages = Math.ceil(data / 25)
    },
    async getVideos () {
      const page = (this.page - 1) * 25
      const { data } = await this.$http.videos.get(`?_limit=25&_start=${page}`)
      this.videos = data.map(i => {
        return {
          ...i,
          thumb: `https://img.youtube.com/vi/${i.id_video}/mqdefault.jpg`
        }
      })
      this.getPages()
    },
    async deleteVideo (id) {
      if (window.confirm('¿Estas seguro de borrar el registro?')) {
        await this.$http.videos.delete(`/${id}`)
        this.getVideos()
      }
    },
    displayVideo (idVideo) {
      this.selectedURL = `https://www.youtube.com/embed/${idVideo}`
      this.showVideo = true
    },
    refresh () {
      this.showAdd = false
      this.getVideos()
    }
  }
}
</script>
